import { TOOL_TABS } from 'gcs-common/constants/toolUIFlags';
import { getUniqueProcessNumber } from 'gcs-common/helper/processTextHelper';
import { processSelected, productSelected } from 'gcs-common/slices/processes/processesSlice';
import { setToolbarTab } from 'gcs-common/slices/uiState/uiStateSlice';
import PropTypes from 'prop-types';
import { useCallback } from 'react';
import { useDispatch } from 'react-redux';
import CubeIcon from '../../../img/cube_primary.svg?react';
import styles from './styles.module.scss';

function ProcessMessage(props) {
  const { process } = props;
  const { Hint } = process;
  // Note: The OR operator here, to read the messages
  // that are already saved in twilio properly
  const ProcessNumber = process.ProcessNumber || process.Number;
  const TypeText = process.ProcessTypeDescription || process.TypeText;
  const Suffix = process.ProcessSuffix || process.Suffix;

  const dispatch = useDispatch();

  // TODO: Is this working here was some selectedProcessFromMessage?
  const setProcess = useCallback(() => {
    dispatch(setToolbarTab({ tab: TOOL_TABS.GCOP }));
    dispatch(
      processSelected({
        selectedProcessNumber: getUniqueProcessNumber(process.ProcessNumber, process.ProcessSuffix),
      }),
    );
    dispatch(productSelected({ selectedProductNumber: undefined }));
  }, [dispatch, process]);

  return (
    <div className={styles.process} role="presentation" onClick={() => setProcess()}>
      <div className={styles.magicCubeWrapper}>
        <CubeIcon alt="process-detail-cube" className={styles.magicCubeSmallIcon} />
      </div>
      <div>
        <div className={styles.processWrapper}>
          <div className={styles.processHeader}>{`${TypeText}: `}</div>
          <span>{getUniqueProcessNumber(ProcessNumber, Suffix)}</span>
          <div className={styles.processDetail}>{Hint}</div>
        </div>
      </div>
    </div>
  );
}

export default ProcessMessage;

ProcessMessage.propTypes = {
  process: PropTypes.object.isRequired,
};
